import { A_Component } from "@adaas/a-concept";



export class A_ServerMiddleware extends A_Component {


    // static get features() {
    //     // return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
    //     //     return A_Feature.Extend({
    //     //         name: A_ServerMiddlewareFeatures.onBeforeInit,
    //     //         scope: [target.constructor],
    //     //     })(target, propertyKey, descriptor);
    //     // }
    // }

}